import { FC } from 'react';

type Props = {
	className?: string;
};

const ClockIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.0001 2C5.58176 2 2 5.58176 2 10.0001C2 14.4184 5.58176 18.0002 10.0001 18.0002C14.4184 18.0002 18.0002 14.4184 18.0002 10.0001C18.0002 5.58176 14.4184 2 10.0001 2ZM10.7443 7.02331C10.7443 6.6123 10.4111 6.27911 10.0001 6.27911C9.58906 6.27911 9.25589 6.6123 9.25589 7.02331V10.0001C9.25589 10.1974 9.33433 10.3868 9.47386 10.5263L10.9622 12.0147C11.2529 12.3053 11.7241 12.3053 12.0147 12.0147C12.3053 11.7241 12.3053 11.2529 12.0147 10.9622L10.7443 9.69184V7.02331Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default ClockIconSolid;
